export default "__VITE_PUBLIC_ASSET__e7a5fd30__"